import { render } from "./Index.vue?vue&type=template&id=4988bdde&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=4988bdde&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4988bdde"],['__file',"resources/js/pages/message/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4988bdde"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4988bdde', __exports__)) {
    console.log('reload')
    api.reload('4988bdde', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=4988bdde&scoped=true", () => {
    console.log('re-render')
    api.rerender('4988bdde', render)
  })

}


export default __exports__